import { useState } from "react";
import { DatePickerCustom, Tab, TabContent, Tabs } from "./style";

import {
  startDateSelector,
  formFilterEmployeeLeaveSelector,
} from "modules/DeclareLeave/redux/selector";
import { useDispatch, useSelector } from "react-redux";

import { Box, IconButton, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useLegacyEffect } from "helper/customHook";

import moment from "moment";
import "moment/locale/vi"; // Import Vietnamese locale
import { useNavigate, useParams } from "react-router-dom";
import pxToRem from "theme/base/pxToRem";
import { ListArriveLate } from "./RequestContent/ArriveLate";
import { ListFeedback } from "./RequestContent/ListRespone";
import { ListLeaveRequest } from "./RequestContent/LeaveRequest";

import EastIcon from "@mui/icons-material/East";
import { declareLeaveURL } from "modules/DeclareLeave/Pages/Main/DeclareLeaveContent/index";
import { getConfigMinDateStart } from "modules/DeclareLeave/redux/getConfigMinDate";
import { ReactComponent as IconArrowHeadDown } from "assets/svg/20-arrowhead-down.svg";
import FilterEmployeeOrder from "./Filter/Filter";
import {
  CATEGORY_TYPE,
  getCategoryOptionStart,
} from "modules/DeclareLeave/redux/getCategoryOption";
import {
  formFilterEmployeeLeaveUpdate,
  resetFilter,
  resetForm,
} from "modules/DeclareLeave/redux/formFilterEmployeeLeave";
import {
  getListEmployeeArriveLateRequestStart,
  resetListEmployeeArriveLateRequest,
} from "modules/DeclareLeave/redux/getListEmployeeArriveLateRequest";
import {
  getListEmployeeLeaveRequestStart,
  resetListEmployeeLeaveRequest,
} from "modules/DeclareLeave/redux/getListEmployeeLeaveRequest";
import {
  getListEmployeeFeedbackRequestStart,
  resetListEmployeeFeedbackRequest,
} from "modules/DeclareLeave/redux/getListEmployeeFeedbackRequest";
import {
  resetControlPageFilter,
  setupControlPage,
} from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";

export const ListEmployeeLeave = () => {
  const { type } = useParams();

  const navigate = useNavigate();
  const locale = "vi";
  if (moment.locale() !== locale) {
    moment.locale(locale);
  }

  const dispatch = useDispatch();

  const startDate = useSelector(startDateSelector);
  const { from, to } = useSelector(formFilterEmployeeLeaveSelector);

  const [open, setOpen] = useState(false);

  const fetchData = (tabSelected?: string) => {
    const tab = tabSelected || type;

    if (!tab || tab === declareLeaveURL.leave) {
      dispatch(resetListEmployeeLeaveRequest());
      dispatch(
        resetControlPageFilter({ id: "employeeLeaveRequest", limit: 60 })
      );
      dispatch(getListEmployeeLeaveRequestStart());
    } else if (tab === declareLeaveURL.feedback) {
      dispatch(resetListEmployeeFeedbackRequest());
      dispatch(
        resetControlPageFilter({ id: "employeeFeedbackRequest", limit: 60 })
      );
      dispatch(getListEmployeeFeedbackRequestStart());
    } else {
      dispatch(resetListEmployeeArriveLateRequest());
      dispatch(
        resetControlPageFilter({ id: "employeeArriveLateRequest", limit: 60 })
      );
      dispatch(getListEmployeeArriveLateRequestStart());
    }
  };

  const handleClickNavigate = (tabContent: string) => {
    // // lấy lại config date để tính toán lại tháng chấm công
    // dispatch(getConfigMinDateStart());

    navigate(
      `/${declareLeaveURL.main}/${declareLeaveURL.employeeOrderLeave}/${tabContent}`
    );
    dispatch(resetForm());
    fetchData(tabContent);
  };

  const handleChangeMonth = (newValue: any, type: "from" | "to") => {
    dispatch(resetForm());

    dispatch(formFilterEmployeeLeaveUpdate({ [type]: newValue }));
    fetchData();
  };

  useLegacyEffect(() => {
    if (!startDate) return;
    dispatch(setupControlPage({ id: "employeeArriveLateRequest", limit: 60 }));
    dispatch(setupControlPage({ id: "employeeFeedbackRequest", limit: 60 }));
    dispatch(setupControlPage({ id: "employeeLeaveRequest", limit: 60 }));
    fetchData();
  }, [startDate]);

  useLegacyEffect(() => {
    return () => {
      // lấy lại config date để tính toán lại tháng chấm công
      dispatch(getConfigMinDateStart());

      dispatch(resetListEmployeeFeedbackRequest());
      dispatch(resetListEmployeeArriveLateRequest());
      dispatch(resetListEmployeeLeaveRequest());
      dispatch(resetFilter());
      dispatch(
        resetControlPageFilter({ id: "employeeLeaveRequest", limit: 60 })
      );
      dispatch(
        resetControlPageFilter({ id: "employeeFeedbackRequest", limit: 60 })
      );
      dispatch(
        resetControlPageFilter({ id: "employeeArriveLateRequest", limit: 60 })
      );
    };
  }, []);

  useLegacyEffect(() => {
    dispatch(
      getCategoryOptionStart({
        categoryType: CATEGORY_TYPE.WORKING_AREA,
      })
    );
    dispatch(
      getCategoryOptionStart({
        categoryType: CATEGORY_TYPE.JOB_TITLE,
      })
    );

    dispatch(
      getCategoryOptionStart({
        categoryType: CATEGORY_TYPE.DEPT_LEVEL1,
      })
    );
    dispatch(
      getCategoryOptionStart({
        categoryType: CATEGORY_TYPE.DEPT_LEVEL2,
      })
    );
    dispatch(
      getCategoryOptionStart({
        categoryType: CATEGORY_TYPE.LEAVE_REASON_TYPE,
      })
    );
  }, [dispatch]);

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingInline={pxToRem(20)}
        flexWrap={"wrap"}
      >
        <Box display={"flex"} alignItems={"center"}>
          <Box
            sx={(theme) => ({
              fontSize: theme.typography.size.lg_18,
              fontWeight: theme.typography.fw_semibold_600,
              color: theme.palette.text.textPrimary,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: pxToRem(5),
            })}
            onClick={() => setOpen(!open)}
          >
            <Typography
              sx={(theme) => ({
                fontSize: theme.typography.size.lg_18,
                fontWeight: theme.typography.fw_semibold_600,
                color: theme.palette.text.textPrimary,
              })}
            >
              Quản lý đơn CBNV{" "}
            </Typography>
            <Box
              sx={(theme) => ({
                height: pxToRem(20),
                width: pxToRem(1),
                background: theme.palette.colorsBase.blue_8,
              })}
            />{" "}
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              adapterLocale={locale}
            >
              <DatePickerCustom
                views={["month", "year"]}
                value={from}
                format="MM - YYYY"
                slots={{ actionBar: () => null }}
                closeOnSelect={true}
                maxDate={to}
                onChange={(value) => handleChangeMonth(value, "from")}
              />
            </LocalizationProvider>
            <EastIcon
              sx={(theme) => ({ fill: theme.palette.colorsBase.gray_5 })}
            />{" "}
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              adapterLocale={locale}
            >
              <DatePickerCustom
                views={["month", "year"]}
                value={to}
                minDate={from}
                format="MM - YYYY"
                slots={{ actionBar: () => null }}
                closeOnSelect={true}
                onChange={(value) => handleChangeMonth(value, "to")}
              />
            </LocalizationProvider>
          </Box>

          <IconButton
            sx={(theme) => ({
              svg: {
                path: {
                  fill: theme.palette.icon.icPrimary,
                },
              },
            })}
            onClick={() => setOpen(!open)}
          >
            <IconArrowHeadDown />
          </IconButton>
        </Box>
        <Tabs>
          <Tab
            active={!type || type === declareLeaveURL.leave}
            onClick={() => handleClickNavigate(declareLeaveURL.leave)}
            fontWeight={500}
          >
            Đơn xin nghỉ
          </Tab>
          <Tab
            active={type === declareLeaveURL.lackOfTime}
            onClick={() => handleClickNavigate(declareLeaveURL.lackOfTime)}
            fontWeight={500}
          >
            Đơn xin đi muộn/về sớm
          </Tab>
          <Tab
            active={type === declareLeaveURL.feedback}
            onClick={() => handleClickNavigate(declareLeaveURL.feedback)}
            fontWeight={500}
          >
            Đơn phản hồi
          </Tab>
        </Tabs>
      </Box>
      <Box paddingInline={pxToRem(20)} width={"100%"}>
        <FilterEmployeeOrder />
      </Box>
      <TabContent
        sx={(theme) => ({
          tbody: {
            tr: {
              "&:hover": {
                backgroundColor: `${theme.palette.background.bgBrandPrimary} !important`,
                cursor: "pointer",
              },
            },
            td: {
              fontSize: `12px !important`,
            },
          },
        })}
      >
        {(!type || type === declareLeaveURL.leave) && <ListLeaveRequest />}
        {type === declareLeaveURL.lackOfTime && <ListArriveLate />}
        {type === declareLeaveURL.feedback && <ListFeedback />}
      </TabContent>
    </>
  );
};
